{
	"title": "Trash",
	"subtitle": "{count, plural, =0 {Empty} one {# item} other {# items}} · kept for 30 days",
	"restore": "Restore",
	"restored": "Restored",
	"emptyTrash": "Empty trash",
	"emptied": "Trash emptied",
	"deleteWord": "DELETE",
	"actionFailed": "Action failed",
	"restoreParentFirst": {
		"recording": "Restore the lecture recording first",
		"material": "Restore the material first",
		"collection": "Restore the folder first",
		"flashcard_set": "Restore the flashcard set first"
	},
	"purgesIn": "deletes in {days, plural, one {# day} other {# days}}",
	"relatedCount": "{count, plural, one {+# related item} other {+# related items}}",
	"empty": {
		"heading": "Trash is empty",
		"description": "Deleted materials, recordings and tools stay here for 30 days."
	},
	"emptyConfirm": {
		"title": "Empty trash?",
		"description": "All items will be permanently deleted. Type DELETE to confirm."
	},
	"filter": {
		"all": "All"
	},
	"offline": {
		"banner": "Internet is required to open trash, restore, or empty it.",
		"action": "Internet required for this action",
		"emptyHeading": "Trash unavailable offline"
	},
	"cascade": {
		"title": "Delete “{title}”?",
		"withChildren": "These will also move to trash:",
		"leaf": "You can restore it within 30 days.",
		"recordingStays": "The lecture recording will remain.",
		"ttl": "You can restore within 30 days.",
		"cancel": "Cancel",
		"confirm": "Delete"
	},
	"entity": {
		"material": "Material",
		"collection": "Folder",
		"note": "Note",
		"test": "Test",
		"flashcard_set": "Flashcards",
		"flashcard": "Card",
		"audio_recap": "Audio recap",
		"visual_analysis": "Visual analysis",
		"essay": "Essay",
		"recording": "Lecture recording",
		"recording_manual_note": "Recording note",
		"tutor_session": "Chat",
		"voice_session": "Voice tutor",
		"study_plan": "Study plan",
		"calendar_event": "Event",
		"glossary_term": "Term",
		"tutor_skill": "Skill",
		"tutor_scenario": "Scenario"
	},
	"intro": {
		"title": "What leaves along with a material",
		"body": "A deleted source takes its notes, tests, card decks and terms with it. All of that lands here, and all of it can be restored.",
		"bullets": [
			"Nested items restore only after their parent",
			"“Empty trash” is not instant — a nightly cleanup wipes it",
			"Filter by type — materials, tests, decks, recordings"
		]
	}
}
